<div class="gc-wrapup-panel">
  <div class="gc-wrapup-panel-form" [attr.data-automation-id]="'gc-wrapup-panel-form'">
    <h3 class="gc-wrapup-panel-title gc-text-bold">{{ 'genesysWrapUpPanel.panelTitle' | translate }}</h3>
    <div class="gc-wrapup-form-row clearfix">

      <button
        mat-button
        [matMenuTriggerFor]="menu"
        (menuOpened)="setDropdown(true)"
        (menuClosed)="setDropdown(false)"
        class="dropdown-toggle">
        <span>{{ selectedItem?.name || ('genesysWrapUpPanel.dropdownDefault' | translate) }}</span>
        <svg-icon icon="{{ !isDropdownOpen ? 'arrow-down' : 'arrow-up' }}" class="arrow-icon"></svg-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button class="wrap-up-code-none" mat-menu-item (click)="changeWrapup(null)">{{ 'genesysWrapUpPanel.none' | translate }}</button>
        <button class="wrap-up-code" mat-menu-item *ngFor="let wrapUpCode of wrapUpCodes" (click)="changeWrapup(wrapUpCode)">
          {{ wrapUpCode.name }}
        </button>
      </mat-menu>

      <p *ngIf="isConversationClosed && !isSelectionValid()" class="wrapup-required-message">{{ 'genesysWrapUpPanel.wrapUpRequiredMessage' | translate }}</p>

    </div>
  </div>

  <div class="gc-wrapup-actions clearfix">
    <button
            [disabled]="disableButtons"
            (click)="onSelect()" *ngIf="!isConversationClosed"
            class="btn btn-dark js-save-wrapup-button"
            [attr.data-automation-id]="'gc-wrapup-save-button'">
      <span [ngSwitch]="communicationType">
        <ng-container *ngSwitchCase="CommunicationType.Email">{{ 'genesysWrapUpPanel.backToEmail' | translate }}</ng-container>
        <ng-container *ngSwitchCase="CommunicationType.Message">{{ 'genesysWrapUpPanel.backToConversation' | translate }}</ng-container>
      </span>
    </button>
    <button *ngIf="isConversationClosed" (click)="onSubmit()"
            [disabled]="!isSelectionValid() || disableButtons"
            class="btn btn-dark js-submit-wrapup-button"
            [attr.data-automation-id]="'gc-wrapup-submit-button'">
      <span>{{ 'genesysWrapUpPanel.wrapUpConversation' | translate}}</span>
    </button>
    <button (click)="onCancel()" *ngIf="!isConversationClosed"
            class="btn btn-dark js-cancel-wrapup-button"
            [attr.data-automation-id]="'gc-wrapup-cancel-button'">
      <span>{{ 'genesysWrapUpPanel.cancel' | translate}}</span>
    </button>
  </div>
</div>
